var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYandexIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_447_2724)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 23.7848C18.5081 23.7848 23.7843 18.5086 23.7843 12.0001C23.7843 5.49155 18.5081 0.215332 11.9996 0.215332C5.49106 0.215332 0.214844 5.49155 0.214844 12.0001C0.214844 18.5086 5.49106 23.7848 11.9996 23.7848Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6944 4.93896H12.5546C10.4521 4.93896 8.66906 6.53937 8.66906 9.64648C8.66906 11.5105 9.53249 12.8848 11.0714 13.5627L8.19974 18.7597C8.10576 18.9294 8.19974 19.0609 8.34984 19.0609H9.68264C9.79514 19.0609 9.8706 19.0234 9.9081 18.9294L12.5171 13.8264H13.4556V18.9294C13.4556 18.9855 13.5117 19.0609 13.5868 19.0609H14.7508C14.8633 19.0609 14.9009 19.0045 14.9009 18.9107V5.12726C14.9009 4.99545 14.8258 4.93896 14.6944 4.93896ZM13.4556 12.6215H12.6672C11.4284 12.6215 10.2272 11.7177 10.2272 9.45823C10.2272 7.10417 11.3534 6.14393 12.4982 6.14393H13.4556V12.6215H13.4556Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_447_2724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexIcon);
export default __webpack_public_path__ + "static/media/YandexIcon.1c5f85a9b0157f214d4976b3bca75cbc.svg";
export { ForwardRef as ReactComponent };